module.exports = "/build/images/plusButtonActive.svg?5cb64fd67c8d1140042bf709bebda071";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/plusButtonActive.svg
// module id = 2440
// module chunks = 0